module.exports = __webpack_public_path__ + "static/AR2-fec2cd6b6909cfa0fe7be35ab3276879.jpg";